import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 12 12\" id=\"icon-calendar\">\r\n<path d=\"M1,2v9h10V2H1z M0,1h12v11H0V1z M2,5h2v2H2V5z M2,8h2v2H2V8z M5,5h2v2H5V5z M5,8h2v2H5V8z M8,5h2v2H8V5z M1,2h10v2H1V2z\r\n\t M8,8h2v2H8V8z M2,0h2v1H2V0z M8,0h2v1H8V0z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/calendar.svg
// module id = 267
// module chunks = 0 1